import { parseWithZod } from '@conform-to/zod'
import { json, redirect, type ActionFunction } from '@remix-run/node'

import { generateImagesStorage } from '#app/utils/generate-images-session.server'
import {
	calculateImageGenerationCost,
	type DBModel,
	type FaceDetailerConfig,
	FaceDetailerSchema,
} from '#app/utils/helpers'
import { checkAndDeductUserCredits } from '#app/utils/helpers.server'

export const DROP_SIZE_MIN = 1
export const DROP_SIZE_MAX = 500
export const DROP_SIZE_DEFAULT = 10

export const action: ActionFunction = async ({ request }) => {
	const formData = await request.formData()

	const submission = parseWithZod(formData, {
		schema: FaceDetailerSchema,
	})
	const session = await generateImagesStorage.getSession(
		request.headers.get('Cookie'),
	)

	// Simplify the early return conditions by combining them
	if (submission.status !== 'success') {
		return json(
			{ result: submission.reply() },
			{
				status: submission.status === 'error' ? 400 : 200,
			},
		)
	}
	function getRandomSeed() {
		return Math.floor(Math.random() * (99999999999 - 10000000) + 10000000)
	}

	const config: FaceDetailerConfig = {
		...submission.value,
		seed: getRandomSeed(),
	}

	const cost = calculateImageGenerationCost(
		config.batchSize,
		config.model as DBModel,
	)
	await checkAndDeductUserCredits(request, cost)

	session.set('detailerFormData', JSON.stringify(config))

	//TODO: check and subtract user credits
	return redirect('/generate/images', {
		headers: {
			'Set-Cookie': await generateImagesStorage.commitSession(session),
		},
	})
}
